
<table class="table table-condensed table-striped" *ngIf="answerTemplate">
<tbody>
  <tr><td width="10%">Name</td><td>{{answerTemplate.name}}</td></tr>
  <tr><td>Date Created</td><td>{{answerTemplate.datecreated}}</td></tr>
  <tr><td>Last Updated</td><td>{{answerTemplate.lastupdated}}</td></tr>
  <tr><td>Description</td><td>{{answerTemplate.description}}</td></tr>
  <tr><td>Version</td><td>{{answerTemplate.version}}</td></tr>
  <tr>
    <td>Task Templates</td>
    <td>
      <ul>
        <li *ngFor="let myTaskTemplate of answerTemplate.questiontemplates;">
          <a [routerLink]="['/task/template/show',myTaskTemplate['server_task_template_id']]">
          {{myTaskTemplate['name']}}
        </a>
        </li>
      </ul>

    </td>
  </tr>
</tbody>
</table>

<fieldset class="buttons text-center" *ngIf="answerTemplate">
    <a [routerLink]="['/answer/template/index']" class="btn btn-primary me-3" (click)="templateIndex()">List</a>
    <a [routerLink]="['/answer/template/edit',server_answer_template_id]" class="btn btn-primary me-3"  >Edit</a>
    <button  class="btn btn-primary me-3" (click)="templateRename()">Rename</button>
    <button class="delete btn btn-danger" (click)="deleteTemplate()" >Delete</button>
 </fieldset>
 <app-spinner *ngIf="!answerTemplate"></app-spinner>

 <app-answer-template-rename [answerTemplate]="answerTemplate" (editAnswerTemplateFinishEvent)="reloadTemplate()"  *ngIf="answerTemplate"></app-answer-template-rename>
